import { UseGqlMutationCallbacks, useMutationWithInvalidation } from '@alice-financial/api'
import { useMutationNotifier } from '../../../notifications/useMutationNotifier'
import {
  CreateOrganizationMutation,
  CreateOrganizationMutationVariables,
  useCreateOrganizationMutation,
} from './createOrganization_gen'

type UseCreateOrganizationOptions = UseGqlMutationCallbacks<
  CreateOrganizationMutation,
  CreateOrganizationMutationVariables
>

export const useCreateOrganization = (mutationOptions?: UseCreateOrganizationOptions) => {
  const { mutateAsync: createOrganization } = useCreateOrganizationMutation()
  const optionsWithNotification = useMutationNotifier({}, mutationOptions)

  return useMutationWithInvalidation(
    createOrganization,
    optionsWithNotification,
    'all' // Invalidate all queries when organization is created
  )
}
